export const FETCH_REQUEST = 'TAG.FETCH_REQUEST';
export const FETCH_SUCCESS = 'TAG.FETCH_SUCCESS';
export const FETCH_FAILURE = 'TAG.FETCH_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/Tag.ts